import {GET, POST} from '../helpers/request';
import {login} from './auth';

export const GET_USER_REQUEST = '@activationView/GET_USER_REQUEST';
export const GET_USER_SUCCESS = '@activationView/GET_USER_SUCCESS';
export const GET_USER_FAILURE = '@activationView/GET_USER_FAILURE';

export const ACTIVATION_REQUEST = '@activationView/ACTIVATION_REQUEST';
export const ACTIVATION_SUCCESS = '@activationView/ACTIVATION_SUCCESS';
export const ACTIVATION_FAILURE = '@activationView/ACTIVATION_FAILURE';

const activationRequest = () => ({
  type: ACTIVATION_REQUEST,
});

const activationSuccess = user => ({
  type: ACTIVATION_SUCCESS,
  user,
});

const activationFailure = error => ({
  type: ACTIVATION_FAILURE,
  error,
});

const userRequest = () => ({
  type: GET_USER_REQUEST,
});

const userSuccess = user => ({
  type: GET_USER_SUCCESS,
  user,
});

const userFailure = error => ({
  type: GET_USER_FAILURE,
  error,
});

export const fetchUser = token => async dispatch => {
  dispatch(userRequest());
  try {
    const user = await GET({endpoint: `/activate/${token}`}, dispatch);
    dispatch(userSuccess(user));
  } catch (err) {
    dispatch(userFailure(err));
  }
};

export const activate = (token, data) => async dispatch => {
  dispatch(activationRequest());
  try {
    const user = await POST({
      endpoint: `/activate/${token}`,
      body: data,
    }, dispatch);
    dispatch(activationSuccess(user));
    dispatch(login(user.username, data.password));
  } catch (error) {
    dispatch(activationFailure(error.message));
  }
};



// WEBPACK FOOTER //
// ./src/actions/activation.js